import React, { useEffect } from "react";
import ReactGA from "react-ga4";
export default function GoogleAnalytics(_ref) {
  var appProps = _ref.appProps;
  useEffect(function () {
    ReactGA.initialize(appProps.googleMeasurementId);
    ReactGA.send({
      hitType: "pageview",
      page: "".concat(window.location.pathname),
      title: "".concat(document.querySelector('title').innerText)
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}